// extracted by mini-css-extract-plugin
module.exports = {"stepsWrapper":"oXKF6","headerWrapper":"_1_b-l","easyStepsTabWrapper":"My_hJ","easyTabImageWrapper":"_1tG_k","easyStepsTabContent":"_3Pu56","cardWrapper":"_2Lo68"};